import { Box, CircularProgress, Divider, Grid } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { Delete, Edit, ExpandMore, Folder } from "@material-ui/icons";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ConfirmPopup from "app/common/Component/Popup/ConfirmPopup";
import { isAdmin } from "app/common/LocalFunction";
import { useStore } from "app/stores";
import { observer } from "mobx-react";
import moment from "moment";
import "moment/locale/vi";
import { memo, useState } from "react";
const PatientListFolder = ({ isMobile, patient }) => {
  moment.locale("vi");
  let isAdminPermission = isAdmin();

  const {
    handleOpenFormCreateOrEdit,
    pageFolder,
    handleSelectFolder,
    folderSelectedView,
    handleDelete,
    handleConfirmDelete,
    openConfirmDeleteFolder,
    handleCloseConfirmDelete,
    handleSyncImageFromVttech,
    loadingFolderId,
    setLoadingFolderId,
  } = useStore().patientManagementStore.imageGeneralTabStore;
  const [listGroup, setlistGroup] = useState({});

  const toggleListGroup = (index, boolean) => {
    setlistGroup((prevStatus) => ({
      ...prevStatus,
      [index]: boolean ? boolean : !prevStatus[index],
    }));
  };

  return (
    <div className="rounded-2xl shadow-sm border-slim p-2">
      <Box className="flex justify-between items-center mb-3">
        <h3 className="font-semibold">Thư mục</h3>

        <div className="gap-2 flex">
          {isAdminPermission && patient?.oldSystemId && (
            <Button
              variant="contained"
              size="small"
              className="create-folder-btn"
              type="button"
              onClick={() => handleSyncImageFromVttech(patient?.oldSystemId)}
            >
              Đồng bộ ảnh
            </Button>
          )}

          <Button
            variant="contained"
            size="small"
            className="create-folder-btn"
            type="button"
            onClick={() => handleOpenFormCreateOrEdit()}
          >
            Tạo thư mục
          </Button>
        </div>
      </Box>
      <Divider />
      <Grid container spacing={1} className="mt-2 folder-list">
        {pageFolder?.content?.map((f, i) => (
          <Grid item xs={12} className="folder-item">
            <div
              className={`folder-info-wrap  ${
                f?.id === folderSelectedView?.id ? "active" : ""
              }`}
            >
              <div className="w-full flex gap-2">
                <div
                  style={{
                    position: "relative",
                    width: "30px",
                    height: "30px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {loadingFolderId === f?.id ? (
                    <CircularProgress size={20} color="primary" />
                  ) : (
                    <Folder style={{ color: "#fbbf24", fontSize: "30px" }} />
                  )}
                </div>
                <div className="flex justify-between flex-1 folder-info">
                  <div
                    className="flex-1"
                    onClick={() => handleSelectFolder(f?.id)}
                  >
                    <span className="font-medium text-sm text-folder">
                      {f?.folderName}
                    </span>
                    <div className="text-xs text-gray-500 text-date flex gap-1">
                      {moment(f?.dateUpload).format("dddd, DD-MM-YYYY")}
                      <span className="text-xs  text-quantity-files">
                        {f?.totalFiles} files
                      </span>
                    </div>
                    <div className="text-xs text-gray-500 ">{f?.note}</div>
                  </div>
                  <div onClick={() => toggleListGroup(f?.id)}>
                    {listGroup[f?.id] ? <ExpandMore /> : <ExpandLessIcon />}
                  </div>
                </div>
              </div>
              {listGroup[f?.id] && (
                <div className="flex gap-2 mt-2 justify-end">
                  <Button
                    variant="outlined"
                    startIcon={
                      <Delete
                        size={16}
                        style={{
                          color: "#f16321",
                        }}
                      />
                    }
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDelete(f?.id);
                    }}
                    className="action-btn-custom"
                  >
                    {!isMobile && "Xóa"}
                  </Button>
                  <Button
                    variant="outlined"
                    startIcon={
                      <Edit
                        size={16}
                        style={{
                          color: "#4276a4",
                        }}
                      />
                    }
                    className="action-btn-custom"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOpenFormCreateOrEdit(f?.id);
                    }}
                  >
                    {!isMobile && "Chỉnh sửa"}
                  </Button>
                </div>
              )}
            </div>
            <hr
              className={`
                    ${
                      i !== pageFolder?.content?.length - 1 &&
                      f?.id !== folderSelectedView?.id
                        ? " "
                        : "w-none "
                    }dark horizontal  opacity-2 w-60 
                    `}
            />
          </Grid>
        ))}
      </Grid>

      <ConfirmPopup
        open={openConfirmDeleteFolder}
        onClose={handleCloseConfirmDelete}
        text={"Bạn có chắc chắn muốn xóa thư mục này?"}
        onConfirm={async () => {
          await handleConfirmDelete();
          toggleListGroup(openConfirmDeleteFolder);
        }}
      />
    </div>
  );
};

export default memo(observer(PatientListFolder));
